export const MACHINERY_DROPDOWN_BASED_ON_MODELS: boolean = true
export const MACHINERY_DROPDOWN_BASED_ON_MACHINES: boolean = true
export const MACHINERY_DROPDOWN_TOP_LIMIT: number = 3
